(ns teamoesterreich.user-mode.page-router
  (:require



    [teamoesterreich.user-mode.event.event-briefing :as p-event-briefing]

    [teamoesterreich.user-mode.event.event-page :as p-event]
    [teamoesterreich.user-mode.info.dsgvo :as dsgvo]

    [teamoesterreich.user-mode.info.impressum :as impressum]
    [teamoesterreich.user-mode.landing.landing :as landing]
    [teamoesterreich.user-mode.location.location-create :as location-create]
    [teamoesterreich.user-mode.location.location-form :as location-form]
    [teamoesterreich.user-mode.location.location-list :as location-list]
    [teamoesterreich.user-mode.location.location-view :as location-view]
    [teamoesterreich.user-mode.neighbor.neighbor :as neighbor]

    [teamoesterreich.user-mode.news.news-details :as news_details]
    [teamoesterreich.user-mode.news.news-list :as news_list]
    [teamoesterreich.user-mode.onboarding.required-fields :as required-fields]
    [teamoesterreich.user-mode.prevent.prevent-help :as prevent-help]
    [teamoesterreich.user-mode.prevent.prevent-overview :as prevent-overview]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-info :as prevent-questionnaire-info]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-intro :as prevent-questionnaire-intro]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-location-info :as prevent-questionnaire-location-info]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-location-intro :as prevent-questionnaire-location-intro]

    [teamoesterreich.user-mode.prevent.prevent-questionnaire-location-question :as prevent-questionnaire-location-question]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-location-summary :as prevent-questionnaire-location-summary]


    [teamoesterreich.user-mode.prevent.prevent-questionnaire-question :as prevent-questionnaire-question]
    [teamoesterreich.user-mode.prevent.prevent-questionnaire-summary :as prevent-questionnaire-summary]

    [teamoesterreich.user-mode.profile.profile-devices :as p-devices]
    [teamoesterreich.user-mode.profile.profile-documents :as p-documents]

    [teamoesterreich.user-mode.profile.profile-events :as p-events]
    [teamoesterreich.user-mode.profile.profile-notifications :as p-notifications]
    [teamoesterreich.user-mode.profile.profile-options :as p-options]



    [teamoesterreich.user-mode.profile.profile-personal :as p-personal]

    [teamoesterreich.user-mode.profile.profile-qualifications :as p-qualifications]
    [teamoesterreich.user-mode.profile.profile-setup :as p-setup]
    [teamoesterreich.user-mode.profile.profile-wanado :as p-wanado]
    [teamoesterreich.user-mode.to-be-done.info :as tbd]
    [teamoesterreich.user-mode.wana-help.helping :as helping]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.user-mode.wana-help.kat.helping-kat :as helping-kat]
    [teamoesterreich.user-mode.wana-help.lebensretter.helping-lebensretter :as helping-lebensretter]
    [teamoesterreich.user-mode.wana-help.neighbor.helping-neighbor :as helping-neighbor]
    [teamoesterreich.user-mode.wana-help.nokat.helping-nokat :as helping-nokat]

    [teamoesterreich.user-mode.wana-help.online.helping-online :as helping-online]

    [teamoesterreich.user-mode.wana-help.tafel.helping-tafel :as helping-tafel]
    [teamoesterreich.user-mode.warnings.warning-location :as warning-location]

    [teamoesterreich.user-mode.warnings.warning-overview :as warning-overview]))


(defn get-page [!act-site]
      (log/out "Actual Site:" @!act-site)

  (case @!act-site

    :landing (landing/get-it)

    :neighbor (neighbor/get-it)

    :wanaPrepare (tbd/get-it ":wanaPrepare")
    :wanaHelp (helping/get-it)
    :wanaBeWarned (tbd/get-it ":wanaBeWarned")
    :wanaNeighbourHelp (tbd/get-it ":wanaNeighbourHelp")


    :wanaHelpOnline (helping-online/get-it)
    :wanaHelpOnline-profile-devices (p-devices/get-it)
    :wanaHelpOnline-profile-personal (p-personal/get-it)

    :wanaHelpLebensretter (helping-lebensretter/get-it)
    :wanaHelpLebensretter-profile-documents [(p-documents/get-it)]
    :wanaHelpLebensretter-profile-personal (p-personal/get-it)


    :wanaHelpNoKat [(helping-nokat/get-it)]
    :wanaHelpNoKat-profile-wanado (p-wanado/get-it)
    :wanaHelpNoKat-profile-qualifications (p-qualifications/get-it)
    :wanaHelpNoKat-profile-personal (p-personal/get-it)

    :wanaHelpKat [(helping-kat/get-it)]
    :wanaHelpKat-profile-wanado (p-wanado/get-it)
    :wanaHelpKat-profile-qualifications (p-qualifications/get-it)
    :wanaHelpKat-profile-personal (p-personal/get-it)

    :wanaHelpTafel [(helping-tafel/get-it)]
    :wanaHelpTafel-profile-personal (p-personal/get-it)
    :wanaHelpTafel-profile-wanado (p-wanado/get-it)

    :wanaHelpNeighbor [(helping-neighbor/get-it)]
    :wanaHelpNeighbor-profile-personal (p-personal/get-it)
    :wanaHelpNeighbor-profile-wanado (p-wanado/get-it)


    ;:location-view [(location-view/get-it)]
    ;:location-form [(location-form/get-it)]
    ;:location-create [(location-create/get-it)]


    :warning-help [(warning-overview/get-it)]
    :warning-overview [(warning-overview/get-it)]
    :warning-location [(warning-location/get-it)]
    :warning-locationView [(location-view/get-it)]
    :warning-locationForm [(location-form/get-it)]
    :warning-locationCreate [(location-create/get-it)]

    :prevent-help [(prevent-help/get-it)]
    :prevent-overview [(prevent-overview/get-it)]
    :prevent-locationView [(location-view/get-it)]
    :prevent-locationForm [(location-form/get-it)]
    :prevent-locationCreate [(location-create/get-it)]




    :questionnaire-intro [(prevent-questionnaire-intro/get-it)]
    :questionnaire-info [(prevent-questionnaire-info/get-it)]
    :questionnaire-question [(prevent-questionnaire-question/get-it)]
    :questionnaire-summary [(prevent-questionnaire-summary/get-it)]

    :questionnaire-location-intro [(prevent-questionnaire-location-intro/get-it)]
    :questionnaire-location-info [(prevent-questionnaire-location-info/get-it)]
    :questionnaire-location-question [(prevent-questionnaire-location-question/get-it)]
    :questionnaire-location-summary [(prevent-questionnaire-location-summary/get-it)]

    :profile (p-options/get-it)
    :profile-personal (p-personal/get-it)
    :profile-qualifications (p-qualifications/get-it)
    :profile-notifications (p-notifications/get-it)
    :profile-documents [(p-documents/get-it)]
    :profile-wanado (p-wanado/get-it)
    :profile-events (p-events/get-it)
    :profile-devices (p-devices/get-it)
    :profile-setup (p-setup/get-it)
    :profile-personal-location-list [(location-list/get-it)]
    :profile-personal-location-form [(location-form/get-it)]
    :profile-personal-location-create [(location-create/get-it)]




    :news-detail [news_details/get-it]
    :news-list [news_list/get-it]

    :event-start [p-event/get-it]
    :event-briefing [p-event-briefing/get-it]


    :impressum (impressum/get-it)
    :dsgvo (dsgvo/get-it)

    :onboard-required [required-fields/get-it]

    [:h5 "Bitte wähle eine Seite (nicht gefunden : `" @!act-site "`)"]))







